import { api } from './client';

/** Un avviso come lo legge la campanella. */
export interface NotificaLetta {
  id: string;
  tipo: string;
  testo: string;
  /** Dove portare chi la apre, come ancora: «richieste/<id>». */
  collegamento: string | null;
  creataIl: string;
  letta: boolean;
}

export interface AvvisiMiei {
  nonLette: number;
  voci: NotificaLetta[];
}

export const notifiche = {
  mie: () => api.get<AvvisiMiei>('/notifiche'),
  letta: (id: string) => api.post<void>(`/notifiche/${id}/letta`, {}),
  tutteLette: () => api.post<void>('/notifiche/lette', {}),
};
